<div id="angularRoot">
  <div fxLayout="row" fxLayoutWrap="fxLayoutWrap" fxShow="true" fxHide="false" id="329625ad-f861-a402-a8ca-49592e032c96">
    <div fxLayout="column" style="height:56px;" fxFlex="100" id="05276e81-8cc2-3303-ae19-84603bc297f7">
      <mat-toolbar id="164488a2-2a37-5db7-bfd4-45fbdce49c97" color="primary" style="position:fixed;z-index:10;padding:0 10px !important;backface-visibility: hidden !important; transform: translate3d(0,0,0) !important;" class="mat-toolbar-layout">
        <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center" id="264ab001-9290-ab22-a00d-77c406a34649">
          <div fxLayout="row" fxLayoutAlign="start" id="8678f2b2-ce78-5e32-3c12-4facbd74c426" *ngIf="showHomeIcon  ">
            <mat-icon class="toolbarFontSize" id="921e579e-89d0-cce0-c6e7-e1def57d180e" (click)="navToHome()">home</mat-icon>
          </div>
        </div>
        <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center" fxShow="true" fxHide="false" id="5b307dcc-6372-10e9-f7ea-c208c85060f9">
          <div fxLayout="row" fxLayoutGap="7px" fxLayoutAlign="end" fxShow="true" fxHide="false" id="523eb62d-32a7-19c2-e76a-3b1945e5e852">
            <div fxLayout="column" fxShow="true" fxHide="false" id="2cea7088-34ff-1c7f-5078-15d7d7526283" *ngFor="let actionButton of actionButtons; let i = index">
              <mat-icon class="toolbarFontSize" id="8e8718d3-a047-a7e0-7c5c-d436308ad355" (click)="broadcastActionEvent(actionButton.event, actionButton.eventAction)">{{actionButton.buttonName}}</mat-icon>
            </div>
            <div fxLayout="column" fxShow="true" fxHide="false" id="81680245-8522-3671-6ec6-8e0aa950d0a1">
              <mat-icon class="toolbarFontSize" id="456afe7e-a8d3-a966-cd47-0e89e5218426" [matMenuTriggerFor]="menu">more_vert</mat-icon>
            </div>
          </div>
        </div>
      </mat-toolbar>
    </div>
  </div>
  <mat-sidenav-container id="40059df6-d00a-1fb6-ca20-bf601a83b9f7" ngClass.gt-xs="dashboard-height-gt-xs" [ngClass.xs]="{&apos;dashboard-height-xs&apos;:true, &apos;fxFill_css&apos;: !utilityS.isAPI19()}">
    <router-outlet id="44f69e23-5b9d-f752-6d77-2193f26175d6"></router-outlet>
  </mat-sidenav-container>
  <mat-menu id="01241695-cb29-e1bc-8687-81b854375c6b" #menu="matMenu">
    <button mat-menu-item="" id="f546bb7e-0203-1a39-cf56-aedecdac0681" routerLink="/bhive/notification"> Dashboard management </button>
    <button mat-menu-item="" id="fa4b5fe9-fc03-8195-e61a-61cf2ecaf265" (click)="logout()"> Log Out </button>
  </mat-menu>
</div>


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/layoutpageComponent/layoutpage.template.html